import { FiltroDeResultados } from './../entity/enumeraveis';
import { SelectItem } from 'primeng/primeng';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { BaseComponent, BaseListComponent } from 'app/base';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'base-list-filter-participantes-por-curso',
    template: `
    <form [formGroup]="filtro" novalidate>
    <div class="ui-g-14 ui-md-12 ui-lg-12">
      <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Código" formControlName="codigo"></form-text>
      <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Título" formControlName="titulo"></form-text>
      <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Nome Capacitadora" formControlName="nome_capacitadora"></form-text>
      <div class="ui-g-12  ui-md-12"></div>
    </div>
    <div class="ui-g-14 ui-md-12 ui-lg-12">
      <form-text class="ui-g-12 ui-md-6 ui-lg-3" label="Membro da comissão" formControlName="membro_comissao">
      </form-text>
      <form-calendar formControlName="data_validade" class="ui-g-12 ui-md-3" label="Data Validade"
        [locale]="locale.ptBR"></form-calendar>
      <div class="ui-g-12  ui-md-12"></div>
    </div>
  </form>
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      <div class="ui-g-5 ui-md-2 ui-lg-2">
        <button pButton type="button" label="Limpar" (click)="limpar()" class="ui-button-white"></button>
      </div>
      <div class="ui-g-2 ui-md-8 ui-lg-8"></div>
      <div class="ui-g-5 ui-md-2 ui-lg-2">
        <button pButton type="button" label="Consultar" (click)="consultar($event)" class="ui-button-madison"></button>
      </div>
    </div>
    `})

export class BaseListFilterParticipantesPorCursoComponent extends BaseComponent {
    @Input() listagem: DatatableComponent;
    @Input() filtro: FormGroup;
    @Input() filtroDeResultados: SelectItem[] = [];
    @Input() baseList: BaseListComponent;
    @Input() urlBusca: string;
    situacaoOptions: any;


    init() {
        this.listagem.selectedRow = [];
        this.loadListAsEnum(this.filtroDeResultados, FiltroDeResultados);
        this.service.ListarTodos('combo/situacao').subscribe(
            data => {
                this.situacaoOptions = data;
            }
        );
    }

    consultar(event: any) {
        const params = new URLSearchParams();
        const formValue = this.filtro.value;
        this.listagem.pDatatableComponent.first = 0;

        for (const key in formValue) {
          if (formValue[key] !== null) {
          params.append(key, formValue[key]);
          }
        }
        sessionStorage.setItem('funcionalidade', this.router.url.split('/')[2]);
        sessionStorage.setItem('filtro', params.toString());
        this.listagem.url = this.baseList.url(this.urlBusca, false, params);
        this.listagem.refresh();
      }

    limpar() {
      sessionStorage.removeItem('filtro')
        this.filtro.reset();
    }
}



// WEBPACK FOOTER //
// ./src/app/base/base-list-filter-participantes-por-curso.component.ts